import { SelectOption as Option } from 'components/select/types';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Marketplace } from 'models/marketplaces';
import { useAppStore } from 'hooks/state/useAppStore';
import { useTransitiveCacheStore } from 'hooks/state/useTransitiveCacheStore';
import { BaseSelect } from '../../BaseSelect';

interface MarketplaceSelectProps {
  selectedMarketplaces?: string[];
  setSelectedMarketplaces?: (value: string[]) => void;
  className?: string;
  showConfirmButton?: boolean;
  disabled?: boolean;
}

const mapMarketplaceToMarketplaceOption = (marketplace: Marketplace): Option<string> => ({
  id: marketplace.name,
  value: marketplace.name,
  label: marketplace.name,
  alt: marketplace.name,
});

export function MarketplaceSelect({
  selectedMarketplaces = undefined,
  setSelectedMarketplaces = undefined,
  className = undefined,
  showConfirmButton = false,
  disabled = false,
}: MarketplaceSelectProps) {
  const intl = useIntl();

  const { allMarketplaces } = useTransitiveCacheStore();
  const allMarketplaceOptions = useMemo(
    () => allMarketplaces.map(mapMarketplaceToMarketplaceOption),
    [allMarketplaces]
  );
  const { marketplaces, setMarketplaces } = useAppStore();
  const { disabledFilters } = useTransitiveCacheStore();

  return (
    <BaseSelect
      id="marketplace-filter"
      className={className}
      label={intl.formatMessage({
        id: 'filter.key.selectedMarketplaces',
        defaultMessage: 'Select Marketplaces',
      })}
      selectedItems={selectedMarketplaces ?? marketplaces ?? []}
      allOptionItems={allMarketplaceOptions}
      setSelectedItems={setSelectedMarketplaces ?? setMarketplaces}
      showConfirmButton={showConfirmButton}
      disabled={disabled || disabledFilters.includes('chnMarketplace')}
    />
  );
}
